// @flow
import { createRequestActionNames } from 'helpers/redux/createRequestActionNames'

export const ORGANIZATION_SETTINGS = createRequestActionNames('ORGANIZATION_SETTINGS', ['GET'])
export const ORGANIZATION_SETTINGS_SET_PENDING_GET = 'ORGANIZATION_SETTINGS_SET_PENDING_GET'
